var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGym1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21H20.5M2 12V21M20 12V21M6.5 7V21M15.5 7V21M1 12H6M21 12H16M5.5 7H16.5M11 7V3.98221M11 3.98221V1.97035C11 1.49615 11 1.25905 11.1464 1.11173C11.6061 0.649394 13.5 1.74303 14.2203 2.18653C14.8285 2.56105 15 3.30914 15 3.98221H11ZM11 21V19M9.5 11V11.5M12.5 11V11.5M9.5 15V15.5M12.5 15V15.5",
    stroke: "#525252",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym1);
export default __webpack_public_path__ + "static/media/gym1.a790e6085b6640683e3a3cc8dbabcdb0.svg";
export { ForwardRef as ReactComponent };